// Do not edit.
import { ShaderStore } from "core/Engines/shaderStore";
import "core/ShadersWGSL/ShadersInclude/bonesDeclaration";
import "core/ShadersWGSL/ShadersInclude/bakedVertexAnimationDeclaration";
import "core/ShadersWGSL/ShadersInclude/instancesDeclaration";
import "core/ShadersWGSL/ShadersInclude/clipPlaneVertexDeclaration";
import "core/ShadersWGSL/ShadersInclude/logDepthDeclaration";
import "core/ShadersWGSL/ShadersInclude/fogVertexDeclaration";
import "core/ShadersWGSL/ShadersInclude/lightVxFragmentDeclaration";
import "core/ShadersWGSL/ShadersInclude/lightVxUboDeclaration";
import "core/ShadersWGSL/ShadersInclude/instancesVertex";
import "core/ShadersWGSL/ShadersInclude/bonesVertex";
import "core/ShadersWGSL/ShadersInclude/bakedVertexAnimation";
import "core/ShadersWGSL/ShadersInclude/clipPlaneVertex";
import "core/ShadersWGSL/ShadersInclude/logDepthVertex";
import "core/ShadersWGSL/ShadersInclude/fogVertex";
import "core/ShadersWGSL/ShadersInclude/shadowsVertex";
import "core/ShadersWGSL/ShadersInclude/vertexColorMixing";

const name = "simpleVertexShader";
const shader = `attribute position: vec3f;
#ifdef NORMAL
attribute normal: vec3f;
#endif
#ifdef UV1
attribute uv: vec2f;
#endif
#ifdef UV2
attribute uv2: vec2f;
#endif
#ifdef VERTEXCOLOR
attribute color: vec4f;
#endif
#include<bonesDeclaration>
#include<bakedVertexAnimationDeclaration>
#include<instancesDeclaration>
uniform view: mat4x4f;uniform viewProjection: mat4x4f;
#ifdef DIFFUSE
varying vDiffuseUV: vec2f;uniform diffuseMatrix: mat4x4f;uniform vDiffuseInfos: vec2f;
#endif
#ifdef POINTSIZE
uniform pointSize: f32;
#endif
varying vPositionW: vec3f;
#ifdef NORMAL
varying vNormalW: vec3f;
#endif
#ifdef VERTEXCOLOR
varying vColor: vec4f;
#endif
#include<clipPlaneVertexDeclaration>
#include<logDepthDeclaration>
#include<fogVertexDeclaration>
#include<__decl__lightVxFragment>[0..maxSimultaneousLights]
#if defined(CLUSTLIGHT_BATCH) && CLUSTLIGHT_BATCH>0
varying vViewDepth: f32;
#endif
#define CUSTOM_VERTEX_DEFINITIONS
@vertex
fn main(input : VertexInputs)->FragmentInputs {
#define CUSTOM_VERTEX_MAIN_BEGIN
#ifdef VERTEXCOLOR
var colorUpdated: vec4f=vertexInputs.color;
#endif
#include<instancesVertex>
#include<bonesVertex>
#include<bakedVertexAnimation>
var worldPos: vec4f=finalWorld* vec4f(vertexInputs.position,1.0);vertexOutputs.position=uniforms.viewProjection*worldPos;vertexOutputs.vPositionW= worldPos.xyz;
#ifdef NORMAL
vertexOutputs.vNormalW=normalize(( finalWorld* vec4f(vertexInputs.normal,0.0)).xyz);
#endif
#ifndef UV1
var uv: vec2f= vec2f(0.,0.);
#else
var uv: vec2f=vertexInputs.uv;
#endif
#ifndef UV2
var uv2: vec2f= vec2f(0.,0.);
#else
var uv2: vec2f=vertexInputs.uv2;
#endif
#ifdef DIFFUSE
if (uniforms.vDiffuseInfos.x==0.)
{vertexOutputs.vDiffuseUV=(uniforms.diffuseMatrix* vec4f(uv,1.0,0.0)).xy;}
else
{vertexOutputs.vDiffuseUV=(uniforms.diffuseMatrix* vec4f(uv2,1.0,0.0)).xy;}
#endif
#include<clipPlaneVertex>
#include<logDepthVertex>
#include<fogVertex>
#include<shadowsVertex>[0..maxSimultaneousLights]
#include<vertexColorMixing>
#define CUSTOM_VERTEX_MAIN_END
}
`;
// Sideeffect
if (!ShaderStore.ShadersStoreWGSL[name]) {
    ShaderStore.ShadersStoreWGSL[name] = shader;
}
/** @internal */
export const simpleVertexShaderWGSL = { name, shader };
